import { Validator } from '@vista-digital/validator';
import { defaultOrderTotalsConfig, orderTotalsConfigValidatorSchema } from '../../order-totals/types/config';
/**
 * Default configuration options for the Order Cart component.
 */
export const defaultOrderCartConfig = Object.assign(Object.assign({}, defaultOrderTotalsConfig), { actionButton: {
        show: true
    }, filmTitle: {
        show: true
    }, tickets: {
        show: true,
        showActionButton: true
    }, items: {
        show: true,
        showImage: true,
        showActionButton: true,
        showRemoveButton: true
    }, showLabels: true });
export const orderCartConfigValidator = Validator.object(Object.assign(Object.assign({}, orderTotalsConfigValidatorSchema), { actionButton: Validator.object({ show: Validator.boolean() }), filmTitle: Validator.object({ show: Validator.boolean() }), tickets: Validator.object({ show: Validator.boolean(), showActionButton: Validator.boolean() }), items: Validator.object({
        show: Validator.boolean(),
        showImage: Validator.boolean(),
        showActionButton: Validator.boolean(),
        showRemoveButton: Validator.boolean()
    }), showLabels: Validator.boolean() }));
